<dx-popup
        [title]="_template.id? 'Update Template' : 'Create Template'"
        [(visible)]="visible" [showCloseButton]="false"
        (visibleChange)="onVisibleChange($event)"
        contentTemplate="popup-content">
    <div *dxTemplate="let data of 'popup-content'">
        <div class="preditorContainer">
            <div class="editorHeader">
                <div class="editorName">
                    <span title="{{ _template.name }}">{{ _template.name }}&nbsp;</span>
                </div>
                <div class="editorButtons">
                    <dx-button icon="save" hint="Save" type="default" stylingMode="outlined" (click)="saveEditor($event)" [disabled]="canBeSaved()"></dx-button>
                    <dx-button icon="remove" hint="Close" type="danger" stylingMode="contained" (click)="visible = false"></dx-button>
                </div>
            </div>
            <div class="editorContent">
                <div class="editorDiv">
                    @if(!showVersions) {
                        <css-template-editor [code]="_template.body" [mode]="'css'" (isUpdated)="codeUpdated($event)"></css-template-editor>
                    } @else {
                        <css-template-versions [template]="_template" (exitVersion)="disableVersion()" (restoredVersion)="restoreVersion($event)"></css-template-versions>
                    }
                </div>
                <div class="editorFormContainer">
                    <dx-form class="editorForm" [formData]="template">
                        <dxi-item dataField="name" [isRequired]="true">
                            <dxi-validation-rule
                                    type="pattern"
                                    pattern="^[a-zA-Z0-9\s-]+$"
                                    message="Invalid. Name must contain letters, numbers and spaces.">
                            </dxi-validation-rule>
                        </dxi-item>
                        <dxi-item dataField="reportType" [isRequired]="true">
                            <dx-tag-box
                                    [items]="reportTypes"
                                    [value]="template.reportType"
                                    (onValueChanged)="onReportTypeChange($event)">
                            </dx-tag-box>
                        </dxi-item>
                        <dxi-item dataField="tenant" [isRequired]="true">
                            <dx-tag-box
                                    [items]="tenants"
                                    [value]="template.tenant"
                                    displayExpr="displayName"
                                    valueExpr="value"
                                    (onValueChanged)="onTenantChange($event)">
                            </dx-tag-box>
                        </dxi-item>
                        <dxi-item dataField="description" editorType="dxTextArea"
                                  [editorOptions]="{minHeight: 120, autoResizeEnabled: true}">
                        </dxi-item>
                    </dx-form>
                    <div class="editorVersionButton">
                        @if(!showVersions) {
                            <dx-button (click)="showVersions = true" type="default" stylingMode="outlined">
                                See Previous Versions
                            </dx-button>
                        } @else {
                            <dx-button (click)="showVersions = false" type="default" stylingMode="outlined">
                                Hide Previous Versions
                            </dx-button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</dx-popup>